export default __webpack_public_path__ + "static/media/cny-check-in.d5608f5e.gif";